<template>
  <div class='col-lg-3'>
    <h4 class="text-center">{{ $t(`profile.kyc.document.type.${[document.Type]}`) }}</h4>
    <kyc-status v-if="documentExists" :kycDocument="document"/>
    <div v-if="documentCreated || documentRefused || !documentExists">
      <span>{{ successInfo }}</span>
      <upload-base64 :multiple='false' :done='addFiles' ref='file_input' class='btn btn-default pt-0'></upload-base64>
      <button @click='$refs.file_input.$refs.input.click();'
        class="btn btn-default button-wide-crowd"
        type='button'>
        {{ $t('profile.kyc.addDocumentPage') }}
      </button>
      <template>
        <p v-if="pages.length">{{ $t('profile.kyc.addedDocuments') }} {{ pages.length }}</p>
        <button v-if="pages.length"
          @click="clear()"
          class="btn btn-default button-wide-crowd"
          type="button">
          {{ $t('profile.kyc.removeDocuments') }}
        </button>
        <button type="button" @click='savePages()' :disabled="!pages.length" class="btn btn-default button-wide-crowd">
          <clip-loader :loading="processing.savePages" :size="'15px'" :color="'white'"></clip-loader>
          <span v-show="!processing.savePages">{{ $t('save') }}</span>
        </button>
      </template>
      <div v-if="documentCreated">
        <button type="button" @click="submitDocument()" class="btn btn-default button-wide-crowd">
          <clip-loader :loading="processing.submit" :size="'15px'" :color="'white'"></clip-loader>
          <span v-show="!processing.submit">{{ $t('profile.kyc.submitForVerification') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import KycStatus from '@/components/KYC/Status';
import UploadBase64 from '@/components/UploadBase64';
import ClipLoader from 'vue-spinner/src/ClipLoader';
import organizationsApi from '@/api/v1/organizations';

const KYC_STATUSES = Object.freeze({
  CREATED: 'CREATED',
  VALIDATION_ASKED: 'VALIDATION_ASKED',
  VALIDATED: 'VALIDATED',
  REFUSED: 'REFUSED',
});

export default {
  components: { UploadBase64, ClipLoader, KycStatus },
  props: {
    document: {
      type: Object,
      default: { Type: 'IDENTITY_PROOF', Id: '', Status: '' },
    },
    organization: Object,
  },
  data() {
    return {
      pages: [],
      successInfo: '',
      processing: {
        savePages: false,
        submit: false,
      },
    };
  },
  computed: {
    documentExists() {
      return this.document.Id;
    },
    documentCreated() {
      return this.document.Status === KYC_STATUSES.CREATED;
    },
    documentRefused() {
      return this.document.Status === KYC_STATUSES.REFUSED;
    },
  },
  methods: {
    addFiles(files) {
      this.pages.push(files.base64.replace(/data:\w+\/\w+;base64,/, ''));
    },
    savePages() {
      this.submitted = true;
      if (!this.document.Id || this.documentRefused) this.createKYCDocument();
      else this.addKYCDocumentPages(this.document.Id);
    },
    submitDocument() {
      this.processing.submit = true;
      organizationsApi.submitKYCDocument(this.document.Id).then((response) => {
        this.processing.submit = false;
        this.$emit('document:submitted', response.data.document);
      }).catch(() => {
        this.processing.submit = false;
      });
    },
    createKYCDocument() {
      this.processing.savePages = true;
      organizationsApi.createKYCDocument(this.document.Type).then((response) => {
        this.processing.savePages = false;
        this.$emit('document:created', response.data.document);
        this.addKYCDocumentPages(response.data.document.Id);
      }).catch(() => {
        this.processing.savePages = false;
      });
    },
    addKYCDocumentPages(documentId) {
      this.processing.savePages = true;

      organizationsApi.addKYCDocumentPages(documentId, this.pages).then(() => {
        this.pages = [];
        this.processing.savePages = false;
        this.successInfo = this.$t('profile.kyc.pagesSaved');
      }).catch(() => {
        this.processing.savePages = false;
      });
    },
    clear() {
      this.pages = [];
      this.successInfo = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// Document.vue?4c90f8e1